/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReferenceRangeModelFieldsFragment = { __typename?: 'ReferenceRangeModel', reference_range_id: string, code: string, category?: string | null, unit?: string | null, risks: Array<{ __typename?: 'ReferenceRangeRiskModel', reference_range_risk_id: string, risk: Types.ReferenceRangeRiskLevel, parameters: Array<{ __typename?: 'ParameterModel', parameter_id: string, code: string, vitall_patient_id?: string | null, lower_bound?: { __typename?: 'ParameterBoundary', value: number, inclusive: boolean } | null, upper_bound?: { __typename?: 'ParameterBoundary', value: number, inclusive: boolean } | null }> }> };

export type GetReferenceRangesQueryVariables = Types.Exact<{
  input: Types.GetReferenceRangesInput;
}>;


export type GetReferenceRangesQuery = { __typename?: 'Query', getReferenceRanges: Array<{ __typename?: 'ReferenceRangeModel', reference_range_id: string, code: string, category?: string | null, unit?: string | null, risks: Array<{ __typename?: 'ReferenceRangeRiskModel', reference_range_risk_id: string, risk: Types.ReferenceRangeRiskLevel, parameters: Array<{ __typename?: 'ParameterModel', parameter_id: string, code: string, vitall_patient_id?: string | null, lower_bound?: { __typename?: 'ParameterBoundary', value: number, inclusive: boolean } | null, upper_bound?: { __typename?: 'ParameterBoundary', value: number, inclusive: boolean } | null }> }> }> };

export type SetCustomParameterMutationVariables = Types.Exact<{
  input: Types.CreateCustomParameterInput;
}>;


export type SetCustomParameterMutation = { __typename?: 'Mutation', setCustomParameter: { __typename?: 'ReferenceRangeModel', reference_range_id: string } };

export type SetCustomParametersMutationVariables = Types.Exact<{
  input: Types.CreateCustomParametersInput;
}>;


export type SetCustomParametersMutation = { __typename?: 'Mutation', setCustomParameters: Array<{ __typename?: 'ReferenceRangeModel', reference_range_id: string, code: string, category?: string | null, unit?: string | null, risks: Array<{ __typename?: 'ReferenceRangeRiskModel', reference_range_risk_id: string, risk: Types.ReferenceRangeRiskLevel, parameters: Array<{ __typename?: 'ParameterModel', parameter_id: string, code: string, vitall_patient_id?: string | null, lower_bound?: { __typename?: 'ParameterBoundary', value: number, inclusive: boolean } | null, upper_bound?: { __typename?: 'ParameterBoundary', value: number, inclusive: boolean } | null }> }> }> };

export type DeleteCustomParametersMutationVariables = Types.Exact<{
  input: Types.DeleteCustomParametersInput;
}>;


export type DeleteCustomParametersMutation = { __typename?: 'Mutation', deleteCustomParameters: boolean };

export type ListReferenceRangeOptionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ListReferenceRangeOptionsQuery = { __typename?: 'Query', listReferenceRangeOptions: Array<{ __typename?: 'ReferenceRangeOptionModel', reference_range_id: string, category?: string | null, code: string }> };

export const ReferenceRangeModelFieldsFragmentDoc = gql`
    fragment ReferenceRangeModelFields on ReferenceRangeModel {
  reference_range_id
  code
  category
  code
  unit
  risks {
    reference_range_risk_id
    risk
    parameters {
      parameter_id
      code
      vitall_patient_id
      lower_bound {
        value
        inclusive
      }
      upper_bound {
        value
        inclusive
      }
    }
  }
}
    `;
export const GetReferenceRangesDocument = gql`
    query getReferenceRanges($input: GetReferenceRangesInput!) {
  getReferenceRanges(input: $input) {
    ...ReferenceRangeModelFields
  }
}
    ${ReferenceRangeModelFieldsFragmentDoc}`;
export function useGetReferenceRangesQuery(baseOptions: Apollo.QueryHookOptions<GetReferenceRangesQuery, GetReferenceRangesQueryVariables> & ({ variables: GetReferenceRangesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferenceRangesQuery, GetReferenceRangesQueryVariables>(GetReferenceRangesDocument, options);
      }
export function useGetReferenceRangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferenceRangesQuery, GetReferenceRangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferenceRangesQuery, GetReferenceRangesQueryVariables>(GetReferenceRangesDocument, options);
        }
// @ts-ignore
export function useGetReferenceRangesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReferenceRangesQuery, GetReferenceRangesQueryVariables>): Apollo.UseSuspenseQueryResult<GetReferenceRangesQuery, GetReferenceRangesQueryVariables>;
export function useGetReferenceRangesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReferenceRangesQuery, GetReferenceRangesQueryVariables>): Apollo.UseSuspenseQueryResult<GetReferenceRangesQuery | undefined, GetReferenceRangesQueryVariables>;
export function useGetReferenceRangesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReferenceRangesQuery, GetReferenceRangesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReferenceRangesQuery, GetReferenceRangesQueryVariables>(GetReferenceRangesDocument, options);
        }
export type GetReferenceRangesQueryHookResult = ReturnType<typeof useGetReferenceRangesQuery>;
export type GetReferenceRangesLazyQueryHookResult = ReturnType<typeof useGetReferenceRangesLazyQuery>;
export type GetReferenceRangesSuspenseQueryHookResult = ReturnType<typeof useGetReferenceRangesSuspenseQuery>;
export type GetReferenceRangesQueryResult = Apollo.QueryResult<GetReferenceRangesQuery, GetReferenceRangesQueryVariables>;
export const SetCustomParameterDocument = gql`
    mutation setCustomParameter($input: CreateCustomParameterInput!) {
  setCustomParameter(input: $input) {
    reference_range_id
  }
}
    `;
export type SetCustomParameterMutationFn = Apollo.MutationFunction<SetCustomParameterMutation, SetCustomParameterMutationVariables>;
export function useSetCustomParameterMutation(baseOptions?: Apollo.MutationHookOptions<SetCustomParameterMutation, SetCustomParameterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCustomParameterMutation, SetCustomParameterMutationVariables>(SetCustomParameterDocument, options);
      }
export type SetCustomParameterMutationHookResult = ReturnType<typeof useSetCustomParameterMutation>;
export type SetCustomParameterMutationResult = Apollo.MutationResult<SetCustomParameterMutation>;
export type SetCustomParameterMutationOptions = Apollo.BaseMutationOptions<SetCustomParameterMutation, SetCustomParameterMutationVariables>;
export const SetCustomParametersDocument = gql`
    mutation setCustomParameters($input: CreateCustomParametersInput!) {
  setCustomParameters(input: $input) {
    ...ReferenceRangeModelFields
  }
}
    ${ReferenceRangeModelFieldsFragmentDoc}`;
export type SetCustomParametersMutationFn = Apollo.MutationFunction<SetCustomParametersMutation, SetCustomParametersMutationVariables>;
export function useSetCustomParametersMutation(baseOptions?: Apollo.MutationHookOptions<SetCustomParametersMutation, SetCustomParametersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCustomParametersMutation, SetCustomParametersMutationVariables>(SetCustomParametersDocument, options);
      }
export type SetCustomParametersMutationHookResult = ReturnType<typeof useSetCustomParametersMutation>;
export type SetCustomParametersMutationResult = Apollo.MutationResult<SetCustomParametersMutation>;
export type SetCustomParametersMutationOptions = Apollo.BaseMutationOptions<SetCustomParametersMutation, SetCustomParametersMutationVariables>;
export const DeleteCustomParametersDocument = gql`
    mutation deleteCustomParameters($input: DeleteCustomParametersInput!) {
  deleteCustomParameters(input: $input)
}
    `;
export type DeleteCustomParametersMutationFn = Apollo.MutationFunction<DeleteCustomParametersMutation, DeleteCustomParametersMutationVariables>;
export function useDeleteCustomParametersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomParametersMutation, DeleteCustomParametersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomParametersMutation, DeleteCustomParametersMutationVariables>(DeleteCustomParametersDocument, options);
      }
export type DeleteCustomParametersMutationHookResult = ReturnType<typeof useDeleteCustomParametersMutation>;
export type DeleteCustomParametersMutationResult = Apollo.MutationResult<DeleteCustomParametersMutation>;
export type DeleteCustomParametersMutationOptions = Apollo.BaseMutationOptions<DeleteCustomParametersMutation, DeleteCustomParametersMutationVariables>;
export const ListReferenceRangeOptionsDocument = gql`
    query listReferenceRangeOptions {
  listReferenceRangeOptions {
    reference_range_id
    category
    code
  }
}
    `;
export function useListReferenceRangeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<ListReferenceRangeOptionsQuery, ListReferenceRangeOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListReferenceRangeOptionsQuery, ListReferenceRangeOptionsQueryVariables>(ListReferenceRangeOptionsDocument, options);
      }
export function useListReferenceRangeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListReferenceRangeOptionsQuery, ListReferenceRangeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListReferenceRangeOptionsQuery, ListReferenceRangeOptionsQueryVariables>(ListReferenceRangeOptionsDocument, options);
        }
// @ts-ignore
export function useListReferenceRangeOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListReferenceRangeOptionsQuery, ListReferenceRangeOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListReferenceRangeOptionsQuery, ListReferenceRangeOptionsQueryVariables>;
export function useListReferenceRangeOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListReferenceRangeOptionsQuery, ListReferenceRangeOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<ListReferenceRangeOptionsQuery | undefined, ListReferenceRangeOptionsQueryVariables>;
export function useListReferenceRangeOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListReferenceRangeOptionsQuery, ListReferenceRangeOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListReferenceRangeOptionsQuery, ListReferenceRangeOptionsQueryVariables>(ListReferenceRangeOptionsDocument, options);
        }
export type ListReferenceRangeOptionsQueryHookResult = ReturnType<typeof useListReferenceRangeOptionsQuery>;
export type ListReferenceRangeOptionsLazyQueryHookResult = ReturnType<typeof useListReferenceRangeOptionsLazyQuery>;
export type ListReferenceRangeOptionsSuspenseQueryHookResult = ReturnType<typeof useListReferenceRangeOptionsSuspenseQuery>;
export type ListReferenceRangeOptionsQueryResult = Apollo.QueryResult<ListReferenceRangeOptionsQuery, ListReferenceRangeOptionsQueryVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useGetReferenceRanges = withQueryResponseHandler(useGetReferenceRangesQuery);
export const useListReferenceRangeOptions = withQueryResponseHandler(useListReferenceRangeOptionsQuery);
export const useSetCustomParameter = withMutationResponseHandler(useSetCustomParameterMutation, "setCustomParameter");
export const useSetCustomParameters = withMutationResponseHandler(useSetCustomParametersMutation, "setCustomParameters");
export const useDeleteCustomParameters = withMutationResponseHandler(useDeleteCustomParametersMutation, "deleteCustomParameters");